<template>
  <section class="section section-lg section-shaped overflow-hidden my-0">
      <div class="shape shape-style-1 shape-primary shape-skew">
      </div>
      <div class="container py-0 pb-lg">
          <div class="row justify-content-between align-items-center">
              <div :class="[{'col-lg-5 mb-5 mb-lg-0': movie.total_previas, 'col-lg-12 mt-3 mb-lg-5': !movie.total_previas}]">
                  <v-wait for="titulo.ficha.load" transition="fade" :duration="750"> 
                    <template slot="waiting">
                      <div class="col">
                        <div class="ph-col-5 mb-5"></div>
                        <div class="ph-container">
                          <div class="ph-col-12"></div>
                          <div class="ph-col-10"></div>
                          <div class="ph-col-12"></div>
                          <div class="ph-col-11"></div>
                        </div>
                      </div>
                    </template>
                    <div>
                      <h1 class="text-white font-weight-light">Sinopse</h1>
                      <p class="lead text-white mt-4">{{movie.sinopse}}</p>
                    </div>
                  </v-wait> 
              </div>
              <div class="col-lg-6 mb-lg-auto" v-if="movie.total_previas">
                  <div class="rounded shadow-lg overflow-hidden transform-perspective-right">
                      <b-carousel id="previas"
                                  controls
                                  indicators>
                          <template v-for="midia in movie.midias">
                            <b-carousel-slide v-for="previa in midia.previas" :key="previa" :img-src="baseURL+previa.imagem" :text=" !midia.origem ? midia.formato : `${midia.formato} - ${midia.origem}`"></b-carousel-slide>
                          </template>              
                      </b-carousel>
                  </div>
              </div>
          </div>
      </div>
  </section>
</template>
<script>
import { BCarousel, BCarouselSlide } from "bootstrap-vue";
export default {
  components: {
    BCarousel,
    BCarouselSlide
  },
  name: 'movieSinopse',
  computed: {
    movie() {
      return this.$store.state.catalog.movie;
    },
    baseURL() {
      return this.axios.defaults.baseURL;
    }
  }
};
</script>
<style lang="scss">
  #previas {
    .carousel-item .carousel-caption p {
      background: rgba(0,0,0,0.8);
      display: inline-block;
      padding: 2px 8px;
      font-size: 0.8em;
      font-weight: bold;
    }
  }
</style>
